import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};

VCA.ProductWalkthrough = (function ($) {

    let ui = {};
    let totalNumOfSteps = 0;
    let DATA_WALKTHROUGH_STEP = 'data-walkthrough-step';

    function cacheUI() {
        ui.$Modal = $('#ProductWalkthroughModal');
        ui.$ContinueToStepsBtn = $('#ContinueToSteps');
        ui.$WelcomeStep = $('.welcome-step');
        ui.$SectionStep = $('.js-walkthrough-step');
        ui.$RemindMeLaterBtn = $('.remind-me-later');
        ui.$CloseBtn = $('.walkthrough-modal__close-btn');
    }

    function bindEvents() {
        ui.$ContinueToStepsBtn.on('click', initWalkthroughSteps);
        ui.$RemindMeLaterBtn.on('click', setCookiesToTrue);
        ui.$CloseBtn.on('click', setCookiesToFalse);
    }

    function walkthroughOnInit() {
        ui.$SectionStep.each((idx,section) => {
            let currentIdxPos = ++idx;
            let btnsContainer = $(section).find('.modal-body__btns');

            $(section).attr(DATA_WALKTHROUGH_STEP, currentIdxPos);

            if ($(section).is(':last-child') == false) {
                $(btnsContainer).append(`
                    <div class="walkthrough-modal__nav__btns">
                        <button class="nav-btn" data-step="${currentIdxPos-1}"><i class="far fa-chevron-left icon nav-icon left"></i></button>
                        <div class="walkthrough-modal__nav__info">
                            <span class="walkthrough-current-step">${currentIdxPos}</span>/<span class="walkthrough-total-steps"></span>
                        </div>
                        <button class="nav-btn" data-step="${currentIdxPos+1}"><i class="far fa-chevron-right icon nav-icon active"></i></button>
                    </div>
                `);
            } else {
                $(btnsContainer).append(`
                    <div class="walkthrough-modal__nav__btns">
                        <button class="nav-btn" data-step="${currentIdxPos-1}"><i class="far fa-chevron-left icon nav-icon left"></i></button>
                        <div class="walkthrough-modal__nav__info">
                            <span class="walkthrough-current-step">${currentIdxPos}</span>/<span class="walkthrough-total-steps"></span>
                        </div>
                        <button class="walkthrough-modal__ty btn btn-sky-outline-alt active">Take A Look</button>
                    </div>
                `);
            }
            totalNumOfSteps++;
        });
        //bind btns 
        $('.walkthrough-modal__nav__btns .nav-btn').on('click', navigateSteps);
        $('.walkthrough-modal__ty').on('click', closeModal);
        //update totalNumOfSteps
        $('.walkthrough-total-steps').html(totalNumOfSteps);
        //add "hide" class to first section (left icon)
        $(`.js-walkthrough-step[${DATA_WALKTHROUGH_STEP}="1"]`).find('.nav-icon.left').hide();
        validateLengthOfSections();
    }

    function displayModal() {
        let cookieResult = getCookie('product-walkthrough');

        if (ui.$Modal.length > 0 && (cookieResult == 'true' || cookieResult == null)) {
            ui.$Modal.modal('show');
        }
    }

    function closeModal() {
        setCookiesToFalse();
        ui.$Modal.modal('hide');
    }

    function initWalkthroughSteps() {
        ui.$WelcomeStep.hide();
        ui.$SectionStep.hide();

        let step1 = $(`.js-walkthrough-step[${DATA_WALKTHROUGH_STEP}="1"]`);
        step1.show();

        lazyLoadImages(step1);
        setTimeout(() => {
            lazyLoadImages(step1);
        }, 100)
    }

    function validateLengthOfSections() {
        if (ui.$SectionStep.length == 1) {
            $(`.js-walkthrough-step[${DATA_WALKTHROUGH_STEP}="1"]`).find('.nav-icon.left').hide();
        }
    }

    function navigateSteps(evt) {
        let step = $(evt.currentTarget).data('step');
        let currentStep = $(`.js-walkthrough-step[${DATA_WALKTHROUGH_STEP}="${step}"]`);
        ui.$SectionStep.hide();
        currentStep.show();

        lazyLoadImages(currentStep);
        setTimeout(() => {
            lazyLoadImages(currentStep);
        }, 100)
    }

    function lazyLoadImages(currentStep) {
        let image = currentStep.find('.modal-content__image > img');
        $(image).attr('src', $(image).data('src'));
        $(image).removeAttr('data-src');
    }

    function setCookiesToTrue() {
        document.cookie = "product-walkthrough= " + true;
        ui.$Modal.modal('hide');
    }

    function setCookiesToFalse() {
        document.cookie = "product-walkthrough= " + false;
        ui.$Modal.modal('hide');
    }

    function getCookie(name) {
        let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); 
        return match ? match[1] : null;
    }

    function init() {
        if ($('#ProductWalkthroughModal').length <= 0) {
            return;
        }
        cacheUI();
        bindEvents();
        walkthroughOnInit();
        displayModal();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ProductWalkthrough.init();
});
